
import { useNavigate } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import PageLayout from '@/components/layout/PageLayout';
import { useProfileData } from '@/hooks/useProfileData';
import { ProfileContent } from '@/components/profile/ProfileContent';

interface ProfilePageProps {
  isNewUser?: boolean;
}

const ProfilePage: React.FC<ProfilePageProps> = ({ isNewUser = false }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  const {
    isLoading,
    isCreatingProfile,
    profile,
    familyMembers,
    inviteCode,
    isSingleMemberFamily,
    isFamilyAdmin,
    familyAdmin,
    canSwitchFamily,
    switchFamilyWarning,
    error,
    isGeneratingCode,
    generateNewInviteCode,
    retryProfileLoad
  } = useProfileData();

  if (!user && !isLoading) {
    navigate('/auth/login');
    return null;
  }

  return (
    <PageLayout 
      title="My Profile" 
      description="View your profile and family information"
    >
      <div className="space-y-6 pb-14">
        <ProfileContent
          profile={profile}
          email={user?.email}
          userId={user?.id}
          isFamilyAdmin={isFamilyAdmin}
          familyAdmin={familyAdmin}
          familyMembers={familyMembers}
          isLoading={isLoading}
          error={error ? new Error(error) : null}
          isCreatingProfile={isCreatingProfile}
          retryProfileLoad={retryProfileLoad}
        />
      </div>
    </PageLayout>
  );
};

export default ProfilePage;
